module.exports = __webpack_public_path__ + "static/img/208.3171cd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/208.png
// module id = 507
// module chunks = 3